import React, { Fragment } from "react";
import "../App.css";

const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
}) => {
  let pages = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pages.push(i);
  }

  return (
    <Fragment>
      <div className="flex py-12 px-2">
        {currentPage === 1 ? (
          <div className="mr-auto ">
            <button disabled className="flex text-gray-300 text-base">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 "
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Previous
            </button>
          </div>
        ) : (
          <div className="mr-auto">
            <button
              className="text-gray-700 flex text-base"
              onClick={() => {
                setCurrentPage(currentPage - 1);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Previous
            </button>
          </div>
        )}

        {/* <div className="pagination">
          {pages.map((page, index) => {
            return (
              <>
                <button
                  key={index}
                  onClick={() => setCurrentPage(page)}
                  className={
                    page === currentPage
                      ? "font-bold text-mhblack font-luxurious bg-mhyellow px-2 rounded-md text-base mx-2"
                      : "mx-2"
                  }
                >
                  {page}
                </button>
              </>
            );
          })}
        </div> */}

        {currentPage >= pages.length ? (
          <div className="ml-auto">
            <button
              disabled
              className="flex text-gray-300 float-right text-base"
            >
              Next{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        ) : (
          <div className="ml-auto">
            <button
              className="text-gray-700 flex text-base"
              onClick={() => {
                setCurrentPage(currentPage + 1);
              }}
            >
              Next
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Pagination;
